import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import button from '../../Style/ButtonStyle.module.css';
import styles from './ResendDialog.module.css';

interface ResendDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (optionalMessage: string) => void;
    messageSnippet: string;
    isLoading?: boolean;
}

const ResendDialog: React.FC<ResendDialogProps> = ({
    isOpen,
    onClose,
    onConfirm,
    messageSnippet,
    isLoading = false
}) => {
    const [optionalMessage, setOptionalMessage] = useState('');
    const maxLength = 100;

    const handleConfirm = () => {
        if (optionalMessage.length > maxLength) {
            toast.error(`Message cannot exceed ${maxLength} characters`);
            return;
        }
        onConfirm(optionalMessage);
    };

    const handleClose = () => {
        setOptionalMessage('');
        onClose();
    };

    const remainingChars = maxLength - optionalMessage.length;

    return (
        <Modal show={isOpen} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Resend Notification</Modal.Title>
            </Modal.Header>
            
            <Modal.Body style={{padding:20}}>
                <div className={styles.snippetSection}>
                    <p className={styles.snippetLabel}>Original message:</p>
                    <div className={styles.snippetBox}>
                        "{messageSnippet}"
                    </div>
                </div>

                <div className={styles.messageSection}>
                    <label htmlFor="optionalMessage" className={styles.messageLabel}>
                        Additional Text (optional):
                    </label>
                    <textarea
                        id="optionalMessage"
                        className={styles.messageTextarea}
                        placeholder="Add an optional message to include with the resent notification..."
                        value={optionalMessage}
                        onChange={(e) => setOptionalMessage(e.target.value)}
                        maxLength={maxLength}
                        rows={4}
                        disabled={isLoading}
                    />
                    <div className={styles.charCount}>
                        {remainingChars} characters remaining
                    </div>
                </div>
            </Modal.Body>
            
            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={handleClose}
                    disabled={isLoading}
                >
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    onClick={handleConfirm}
                    disabled={isLoading}
                >
                    {isLoading ? 'Resending...' : 'Resend'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ResendDialog;
